// extracted by mini-css-extract-plugin
export default {"container":"Formula_container__HoQud","rSquared":"Formula_rSquared__OAlbS"};